module.exports = __webpack_public_path__ + "static/media/copy-to-clipboard-icon.81b360b9.png";